const al = {
  refill_title: 'Refill',
  refill_title_more_info: 'Info',
  refill_label_active_bundle: 'Active bundle name',
  refill_label_more_info: 'Info',
  refill_label_choose_amount: 'Zgjidh Paketën',
  refill_label_payment_method: 'Mënyra e Pagesës',
  refill_label_airtime: 'Kredit %1$s ',
  refill_label_congratulations: 'Urime!',
  refill_label_problem: 'Ups, ka ndodhur një problem!',
  refill_label_dates_used: 'Ditë të kaluara',
  refill_label_available_days: 'Ditë të mbetura',
  refill_bundle_availability_description: 'Paketa është aktive deri më %1$s.',
  refill_insufficient_airtime_description: 'Ti nuk ke kredit të mjaftueshëm. Rimbush llogarinë tani dhe vazhdoni me blerjen e paketës.',
  refill_purchased_package_description: 'Paketa përmban %1$s për %1$s.',
  refill_purchased_package_information: 'Tani ju keni %1$s shtese në llogarinë tuaj.',
  refill_purchase_product_confirm: 'Je i sigurt që do të blesh këtë paketë?',
  refill_overwrite_bundle_confirm: 'Je i sigurt që do të mbishkruash paketën tënde aktive?',
  refill_button_confirm: 'Konfirmo',
  refill_button_cancel: 'Anullo',
  refill_button_go_back: 'Kthehu',
  refill_button_yes: 'Po',
  refill_button_continue: 'Vazhdo',
  refill_button_loading: 'Ne përpunim',
  refill_button_top_up: 'Rimbush',
  refill_currency: 'lekë',

  refill_label_payment_options: 'Mënyrat e pagesës',
  refill_payment_option_airtime: 'Balancë',
  refill_payment_option_bill: 'Faturë',
  refill_payment_option_next: 'Vazhdo',

  refill_confirm_header_title: 'Aktivizim pakete',
  refill_confirm_title: 'A je i/e sigurtë që do të aktivizosh këtë paketë?',
  refill_confirm_cost: 'Kosto ',
  refill_confirm_desc: 'Ti do të tarifohesh në faturën e rradhës.',
}

export default al
